// extracted by mini-css-extract-plugin
export default {"payments":"Payments_payments__l4pil","heading":"Payments_heading__zkX8g","cards":"Payments_cards__SDtcx","seeDetails":"Payments_seeDetails__Y7Tst"};